export const SET_BACKOFFICE_STORE = 'SET_BACKOFFICE_STORE'
